import { useQuery, UseQueryOptions } from '@tanstack/react-query'
import type { Item } from 'typings'
import { GetAffiliatesAPIResponse } from 'typings/fulfillment'
import { useFetch } from './useFetch'

export function useAffiliates(options?: UseQueryOptions<Item[]>) {
  const { fetcherWrapper } = useFetch()

  const url = new URL(
    `/api/proxy/fulfillment/pvt/affiliates`,
    window.location.origin
  )

  async function fetcher() {
    return fetcherWrapper(url.toString())
      .then((r) => r.json())
      .then((r: GetAffiliatesAPIResponse) =>
        r.map(({ name, id }) => ({ name, id }))
      )
  }

  return useQuery({
    queryKey: ['affiliates'],
    queryFn: fetcher,
    ...options,
  })
}
